import React from 'react';
import TextField from '../../../../components/Textfields/TextField';
import AutoCompleteCountry from '../../../../components/AutoComplete/AutoCompleteCountry';
import AutoCompletePlace from '../../../../components/AutoComplete/AutoCompletePlace';
import AutoCompleteState from '../../../../components/AutoComplete/AutoCompleteState';
import { useAccountContext } from '../Data/accountContext';
import InputMask from 'react-input-mask';

export default function FormAccountAddress({
  objectName,
  isBusinessAddress,
  validation,
  index,
}) {
  const { account, setAccount } = useAccountContext();

  const handleChange = (e, autocomplete) => {
    const copy = { ...account };

    // get object or array index
    let o = copy[objectName];
    if (index !== undefined) {
      o = o[index];
    }

    // if from autocomplete place
    if (autocomplete) {
      o.address1 = autocomplete.address1;
      o.address2 = autocomplete.address2;
      o.city = autocomplete.city;
      o.state = autocomplete.state;
      o.country = autocomplete.country;
      o.zip = autocomplete?.zipCode || '';
    } else {
      const input = e.currentTarget.name ? e.currentTarget : e.target;

      // if field is country set the state to empty
      // `ountry` to also catch primaryCountry and country without having to use tolowercase
      if (
        input.name.includes('ountry') &&
        (input.value === 'US' || (input.value !== 'US' && o.country === 'US'))
      ) {
        o.state = '';
        o.zip = '';
      }

      o[input.name] = input.value;
    }

    if (index !== undefined) {
      copy[objectName][index] = o;
    } else {
      copy[objectName] = o;
    }

    setAccount({ ...copy });
  };

  // get object or array index
  let validationObject = validation[objectName];
  let modelObject = account[objectName];

  if (index !== undefined) {
    validationObject = validationObject ? validationObject[index] : {};
    modelObject = modelObject[index];
  }

  return (
    <React.Fragment>
      <div className="grd-row nm">
        <div className="grd-cell">
          <AutoCompletePlace
            required={true}
            error={!!validationObject?.address1}
            msg={validationObject?.address1}
            max={100}
            name="address1"
            label={!isBusinessAddress ? 'Address 1' : 'Business Address 1'}
            placeholder={!isBusinessAddress ? 'Address 1' : 'Business Address 1'}
            value={modelObject.address1 || ''}
            onChange={handleChange}
            setAddressData={(name, address) => {
              handleChange({ currentTarget: { name } }, address);
            }}
          />
        </div>
        <div className="grd-cell">
          <TextField
            max={100}
            name="address2"
            label={!isBusinessAddress ? 'Address 2' : 'Business Address 2'}
            placeholder={!isBusinessAddress ? 'Address 2' : 'Business Address 2'}
            type="text"
            value={modelObject.address2}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="grd-row">
        <div className="grd-cell">
          <TextField
            required={true}
            error={!!validationObject?.city}
            msg={validationObject?.city}
            max={80}
            name="city"
            label="City"
            placeholder="City"
            type="text"
            value={modelObject.city}
            onChange={handleChange}
          />
        </div>
        <div className="grd-cell">
          {modelObject.country === 'US' ? (
            <AutoCompleteState
              required
              error={!!validationObject?.state}
              msg={validationObject?.state}
              name="state"
              label="State"
              placeholder="State"
              value={modelObject.state || ''}
              onChange={handleChange}
            />
          ) : (
            <TextField
              max={50}
              name="state"
              label="State"
              placeholder="State"
              type="text"
              value={modelObject.state}
              onChange={handleChange}
            />
          )}
        </div>
      </div>
      <div className="grd-row">
        <div className="grd-cell">
          <AutoCompleteCountry
            required={true}
            error={!!validationObject?.country}
            msg={validationObject?.country}
            name="country"
            label="Country"
            placeholder="Country"
            value={modelObject.country || ''}
            onChange={handleChange}
          />
        </div>
        <div className="grd-cell">
          <InputMask
            mask={modelObject.country === 'CA' ? '*** ***' : '**********'}
            value={modelObject.zip}
            beforeMaskedValueChange={(newZip, oldZip) => {
              if (newZip.value !== oldZip.value) {
                handleChange({
                  currentTarget: {
                    name: 'zip',
                    value: newZip.value,
                  },
                });
              }

              return {
                value: newZip.value,
                selection: newZip.selection,
              };
            }}
          >
            {() => (
              <TextField
                fullWidth={true}
                error={!!validationObject?.zip}
                msg={validationObject?.zip}
                required={
                  modelObject.country === 'US' ||
                  modelObject.country === 'CA'
                }
                id="zip"
                name="zip"
                label="Zip Code"
                placeholder="Zip Code"
                InputLabelProps={{ shrink: true }}
              />
            )}
          </InputMask>
        </div>
      </div>
    </React.Fragment>
  );
}
